'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default from 'react';
import { Box } from './index.css.js';
import DefaultAvatar from '../Images/DefaultAvatar/index.js';

function Avatar(_a) {
    var image = _a.image, alt = _a.alt, rest = __rest(_a, ["image", "alt"]);
    return React__default.createElement(Box, __assign({}, rest), image ? React__default.createElement("img", { src: image, alt: alt !== null && alt !== void 0 ? alt : 'avatar user' }) : React__default.createElement(DefaultAvatar, { size: 88 }));
}

export { Avatar as default };
//# sourceMappingURL=index.js.map
